import { registerLocaleData } from '@angular/common';
import { Component, HostListener, OnInit } from '@angular/core';
import { Title } from '@angular/platform-browser';
import { ActivatedRoute, Router, RouterOutlet } from '@angular/router';
import { Logger } from '@app/core';
import { DeviceService } from '@app/core/services/device.service';
import { SwUpdateService } from '@app/core/services/sw.update.service';
import localeDe from '@angular/common/locales/de';
import localeDeAT from '@angular/common/locales/de-AT';

import { environment } from '@env/environment';

const log = new Logger('App');

@Component({
  selector:    'app-root',
  templateUrl: './app.component.html',
  styleUrls:  ['./app.component.scss'],
  standalone: true,
  imports:    [RouterOutlet]
})


export class AppComponent implements OnInit {
  constructor(
    private router: Router,
    private activatedRoute: ActivatedRoute,
    private titleService: Title, private deviceService: DeviceService,
    private swUpdateService: SwUpdateService
  ) {
    registerLocaleData(localeDeAT);
    registerLocaleData(localeDe);
  }

  ngOnInit() {
    // Setup logger
    if (environment.production) {
      Logger.enableProductionMode();
    }

    this.deviceService.init();
    this.swUpdateService.setupServiceWorker();



  }

  // Formatierung beim kopieren entfernen
  // beim Einfügen gibt es immer wieder Probleme
  @HostListener('document:copy', ['$event'])
  removeFormattingOnCopy(ev:ClipboardEvent) {
    // do something meaningful with it
    const text_only = document.getSelection().toString();
    const clipdata = ev.clipboardData || (window as any).clipboardData;
    clipdata.setData('text/plain', text_only);
    clipdata.setData('text/html', text_only);
    ev.preventDefault();
  }


}

export const FULLSCREEN_DIALOG = 'dialog-fullscreen';
export const LARGE_DIALOG = 'dialog-large';
export const MEDIUM_DIALOG = 'dialog-medium';
export const SMALL_DIALOG = 'dialog-small';
